import request from '@/config/axios'

// 商家结算单 - 平台模式
export const getSettlementPage = (params: any) => {
  return request.get({ url: '/scenic/settlement/page', params })
}

export const getSettlement = (id: number) => {
  return request.get({ url: '/scenic/settlement/get', params: { id } })
}

export const generateSettlements = (periodStart: string, periodEnd: string) => {
  return request.post({ url: '/scenic/settlement/generate', params: { periodStart, periodEnd } })
}

export const executeSettlement = (id: number) => {
  return request.post({ url: '/scenic/settlement/execute', params: { id } })
}

export const cancelSettlement = (id: number, reason: string) => {
  return request.post({ url: '/scenic/settlement/cancel', params: { id, reason } })
}
